import {call, put, select, take} from "redux-saga/effects";
import {getType} from "typesafe-actions";
import {addLives} from "../actions";
import {IApplicationState} from "../../index";
import {closeAds, watchAds} from "../../advertisement/actions";
import {showAlert} from "../../dialog-manager/dialogs/showAlert";
import {AnyAction} from "redux";
import {closeDialog, showDialog} from "../../dialog-manager/actions";
import playSound from "../../../shared/sounds/playSound";
import i18n from "../../../shared/i18n";

export default function* watchAdForLife() {
    while (true) {
        yield take((action: AnyAction) => {
            return action.type === getType(showDialog)
                && action.payload.type === "NoLivesDialog";
        });

        const { payload } = yield take(getType(closeDialog));

        if (!payload || payload.value !== "watchAd")
            continue;

        const rewardedAdIsAvailable = yield select(({ advertisement }: IApplicationState) => advertisement.rewardedAdIsAvailable);
        if (!rewardedAdIsAvailable)
            continue;

        yield put(watchAds({
            adType: "rewarded",
            reward: "lives"
        }));

        const { payload: { success } } = yield take(getType(closeAds));

        if (!success) {
            yield call(showAlert,
                i18n("gameplay.rewardedad.failed.header"),
                i18n("gameplay.rewardedad.failed.desc"));

            continue;
        }

        playSound("life-gained", 0.2);
        yield put(addLives(1, "rewarded_ad_for_lives"));
    }
}

